// extracted by mini-css-extract-plugin
export var blogCard = "blogCards-module--blogCard--556a7";
export var blogCards = "blogCards-module--blogCards--ac0bf";
export var borderContainer = "blogCards-module--borderContainer--e977c";
export var button = "blogCards-module--button--f298a";
export var cardContainer = "blogCards-module--cardContainer--0cbd3";
export var categoryTitle = "blogCards-module--categoryTitle--36e69";
export var dark = "blogCards-module--dark--f34d8";
export var displayGrayLine = "blogCards-module--displayGrayLine--1e21f";
export var light = "blogCards-module--light--753b1";
export var paddingBottomlg = "blogCards-module--paddingBottomlg--6a66d";
export var paddingBottommd = "blogCards-module--paddingBottommd--829f9";
export var paddingBottomsm = "blogCards-module--paddingBottomsm--10e9c";
export var paddingBottomxl = "blogCards-module--paddingBottomxl--75c7b";
export var paddingBottomxs = "blogCards-module--paddingBottomxs--cc2b6";
export var paddingToplg = "blogCards-module--paddingToplg--e88a2";
export var paddingTopmd = "blogCards-module--paddingTopmd--0333e";
export var paddingTopsm = "blogCards-module--paddingTopsm--e8c93";
export var paddingTopxl = "blogCards-module--paddingTopxl--00a10";
export var paddingTopxs = "blogCards-module--paddingTopxs--f8920";
export var text = "blogCards-module--text--9b26a";
export var titleRow = "blogCards-module--titleRow--d0cb3";
export var twoColumnWithNewsfeed = "blogCards-module--twoColumnWithNewsfeed--52b43";
export var white = "blogCards-module--white--23d74";
export var wrapper = "blogCards-module--wrapper--ae61f";